<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Scout",
  components: {
    Header,
    Footer
  },
  props: {
    bgImage: {
      type: String,
      default: require("../assets/first-view-bg.png")
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(function() {
      // 高さを揃えたい要素を取得
      const nodes = document.getElementsByClassName("feature-point-content");
      let maxHeight = "0px";

      // 各要素の高さを取得
      for (let i = 0; i < nodes.length; i++) {
        const height = window.getComputedStyle(nodes[i]).height;
        if (maxHeight < height) {
          maxHeight = height;
        }
      }

      // 一番高いやつに高さを合わせる
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].style.height = maxHeight;
      }
    });
  }
};
</script>

<template>
  <div class="top">
    <Header />
    <div class="first-view" :style="{ backgroundImage: `url(${bgImage})` }">
      <div class="first-view_row">
        <div class="messages">
          <p class="sub-title_text">
            美容専門のインフルエンサー
            <br class="visible-xs" />マーケティングの決定版
          </p>
          <h1 class="main-title_text">miraスカウト</h1>
        </div>
      </div>
    </div>
    <div class="entrance-section">
      <div class="entrances">
        <div class="company-entrance entrance">
          <div class="entrance_content">
            <p class="entrance_label">企業の方はこちら</p>
            <a class="entrance_button" target="_blank" href="https://mira-pr.appspot.com/">企業ページへ</a>
          </div>
        </div>
        <div class="influencer-entrance entrance">
          <div class="entrance_content">
            <p class="entrance_label">インフルエンサーの方はこちら</p>
            <a
              class="entrance_button"
              target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLScOAi4bzhWYlJUFeRGZkInVrKA2tOW10Vg08kD8mBHISPuBLQ/viewform?usp=send_form"
            >登録ページへ</a>
          </div>
        </div>
      </div>
    </div>
    <div class="feature-section">
      <h2 class="section-title">サービスの特徴</h2>
      <ul class="feature-points">
        <li class="feature-point">
          <div class="feature-point-content">
            <div>
              <h3 class="feature-point_label">女性が中心です</h3>
              <p>インスタグラム・Youtube・TikTokで活躍中の女性インフルエンサーが登録されています。</p>
            </div>
          </div>
        </li>
        <li class="feature-point">
          <div class="feature-point-content">
            <div>
              <h3 class="feature-point_label">20〜30代</h3>
              <p>20~30代のインフルエンサーの方がmiraスカウトに登録しています。</p>
            </div>
          </div>
        </li>
        <li class="feature-point">
          <div class="feature-point-content">
            <div>
              <h3 class="feature-point_label">​見た目で検索</h3>
              <p>AI顔写真診断で見た目のタイプを抽出してその結果を元に検索が可能です。</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="flow-section">
      <h2 class="section-title">ご利用の流れ</h2>
      <ul class="flows">
        <li class="flow-row">
          <div class="flow-left">
            <div class="flow-left-content">
              <p class="flow_label">STEP1</p>
              <p class="flow_title">ヒヤリング</p>
            </div>
          </div>
          <div class="flow-right">
            <p>募集したいインフルエンサーの詳細とオリエン内容を弊社のスタッフがヒヤリングさせていただきます。</p>
          </div>
        </li>
        <li class="flow-row">
          <div class="flow-left">
            <div class="flow-left-content">
              <p class="flow_label">STEP2</p>
              <p class="flow_title">募集開始</p>
            </div>
          </div>
          <div class="flow-right">
            <p>弊社内でキャンペーンの審査を行います。問題がなかった場合、インフルエンサーの募集を開始します。</p>
          </div>
        </li>
        <li class="flow-row">
          <div class="flow-left">
            <div class="flow-left-content">
              <p class="flow_label">STEP3</p>
              <p class="flow_title">選定&承認</p>
            </div>
          </div>
          <div class="flow-right">
            <p>キャンペーンへ応募されたインフルエンサーの中から依頼する方を選考します。</p>
          </div>
        </li>
        <li class="flow-row">
          <div class="flow-left">
            <div class="flow-left-content">
              <p class="flow_label">STEP4</p>
              <p class="flow_title">事前チェック</p>
            </div>
          </div>

          <div class="flow-right">
            <p>インフルエンサーの方が撮影・投稿の準備をします。その投稿内容を事前にご確認いただきます。</p>
          </div>
        </li>
        <li class="flow-row">
          <div class="flow-left">
            <div class="flow-left-content">
              <p class="flow_label">STEP5</p>
              <p class="flow_title">本番投稿</p>
            </div>
          </div>

          <div class="flow-right">
            <p>事前チェックを承認していただくと、規定の日にインフルエンサーの方が本人のアカウントから投稿します。</p>
          </div>
        </li>
      </ul>
    </div>
    <Footer />
  </div>
</template>

<style scoped>
.visible-xs {
  display: none;
}
.flows {
  max-width: 960px;
  margin: 0px auto;
}
.flow-row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.flow-left {
  width: 120px;
  padding: 16px;
  background-color: #ffffff;
}
.flow-left-content {
  width: 100%;
}
.flow_label {
  font-size: 16px;
  text-align: center;
}
.flow_title {
  font-size: 12px;
  text-align: center;
}
.flow-right {
  flex: 1;
  padding-left: 16px;
}
.flow-section {
  width: 100%;
  padding: 96px 16px;
  background-color: #f5f5f7;
}
.section-title {
  text-align: center;
  font-weight: 300;
  margin-bottom: 32px;
}
.feature-section {
  width: 100%;
  max-width: 960px;
  margin: 0px auto;
  padding: 96px 0px;
}
.feature-points {
  display: flex;
  margin: 0px -8px;
}
.feature-point-content {
  display: flex;
  padding: 32px 24px;
  background-color: #f5f5f7;
}
.feature-point_label {
  font-size: 24px;
  font-weight: 300;
  color: #140a1e;
  text-align: center;
  margin-bottom: 24px;
}
.feature-point {
  flex: 1;
  padding: 0px 8px;
}
.entrance-section {
  height: 152px;
  position: relative;
}
.entrances {
  display: flex;
  width: 640px;
  height: 200px;
  padding: 24px;
  margin-left: -320px;
  background-color: #ffffff;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 50%;
  top: -48px;
}
.entrance {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.entrance_content {
  width: 100%;
  padding: 0px;
}
.entrance_label {
  font-size: 16px;
  font-weight: 400;
  color: #140a1e;
  text-align: center;
  margin-bottom: 16px;
}
.entrance_button {
  display: block;
  width: 100%;
  border-radius: 25px;
  padding: 12px 24px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  background-color: #e4aca1;
}
.company-entrance {
  border-right: 1px solid #c8c3d7;
  padding-right: 24px;
}
.influencer-entrance {
  padding-left: 24px;
}
.top {
  position: relative;
  background-color: #ffffff;
}
.first-view {
  width: 100%;
  padding: 148px 0px 96px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.first-view_row {
  width: 100%;
  max-width: 960px;
  margin: 0px auto;
}
.main-title_text {
  font-size: 48px;
  color: #ffffff;
  text-align: center;
}
.sub-title_text {
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 8px;
}
.store-btns {
  margin-top: 32px;
}
.apple-btn {
  display: block;
  width: 160px;
}
.mira-app {
  width: 400px;
  position: absolute;
  top: 0px;
  left: 50%;
  margin-left: -200px;
}

@media screen and (max-width: 768px) {
}
@media screen and (max-width: 480px) {
  .visible-xs {
    display: block;
  }
  .feature-section {
    padding: 64px 16px;
  }
  .feature-points {
    display: block;
  }
  .feature-point-content {
    margin-bottom: 16px;
  }
  .flow-section {
    padding: 64px 16px;
  }
  .flow-row {
    align-items: inherit;
  }
  .flow-left {
    display: flex;
    width: 120px;
    align-items: center;
    justify-content: center;
  }
  li.feature-point-content:last-child {
    margin-bottom: 0px;
  }
  .entrance-section {
    height: 216px;
    padding: 0px 16px;
  }
  .entrances {
    display: block;
    width: -webkit-calc(100% - 32px);
    height: auto;
    left: 16px;
    margin-left: auto;
  }
  .company-entrance {
    border-right: 0px solid #c8c3d7;
    padding-right: 0px;
  }
  .influencer-entrance {
    padding-left: 0px;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #c8c3d7;
  }
  .first-view {
    padding: 96px 0px 64px;
  }
  .first-view_row {
    display: block;
    width: 100%;
    padding: 0px 16px;
  }
  .main-title_text {
    font-size: 32px;
    text-align: center;
    line-height: 40px;
    margin-bottom: 20px;
  }
  .sub-title_text {
    font-size: 16px;
    text-align: center;
  }
}
@media screen and (max-width: 320px) {
}
</style>



// WEBPACK FOOTER //
// src/screens/Scout.vue